import { useEffect, useState } from "react";
import "./find-your-table.scss";
import LoadingOverlay from "../../components/loading/LoadingOverlay";
import tableSeating from "./table-seating.json";

export default function FindYourTable() {
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredGuests, setFilteredGuests] = useState(tableSeating);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setImagesLoaded(true);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    const cleanSearch = searchTerm.trim().toLowerCase();

    const filtered = tableSeating
      .filter((guest) => {
        const lowerName = guest.Name.toLowerCase();
        const lowerNicknames = guest.Nicknames.trim().toLowerCase();

        // 1. Handle Easter Egg
        if (lowerName === "raikou") {
          return cleanSearch === "raikou";
        }

        // 2. Full Name Multi-Word Match (e.g., "John Smith")
        if (cleanSearch.includes(" ")) {
          return lowerName.includes(cleanSearch);
        }

        // 3. Strict Nickname Match (Must type the exact, full nickname)
        if (lowerNicknames && cleanSearch === lowerNicknames) {
          return true;
        }

        // 4. Strict "Starts With" Match for normal first/last names
        // We split by spaces to check individual parts of the legal name
        const nameParts = lowerName.split(" ");
        return nameParts.some((part) => part.startsWith(cleanSearch));
      })
      .sort((a, b) => a.Name.localeCompare(b.Name));

    setFilteredGuests(filtered);
  }, [searchTerm]);

  return (
    <>
      <LoadingOverlay isLoading={!imagesLoaded} />
      {imagesLoaded && (
        <div
          className={`find-your-table margin-0 padding-bottom-60 ${
            imagesLoaded ? "fade-in" : ""
          }`}
        >
          <div className="find-your-table-content">
            <div className="title-search-bar">
              <h1 className="cormorant-500 text-dark font-size-8 letter-spacing-2">
                Find Your Table
              </h1>
              <input
                type="search"
                placeholder="search by name"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <p className="cormorant-italic-500 margin-top-6 margin-bottom-5 letter-spacing-1">
                Please don't forget to take your envelope!
              </p>
            </div>
            <div className="table-list">
              {filteredGuests.map((guest, index) => {
                if (searchTerm === "") {
                  return null; // skip rendering if search term is empty
                }
                if (guest.Name === "") {
                  return null; // skip null entries
                } else {
                  return (
                    <div key={index} className="table-list-item item-fade-in">
                      <div className="guest-name letter-spacing-1">
                        {guest.Name}
                      </div>
                      <div className="table-number">{guest.Table}</div>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
